import React from "react";
import { Card } from "react-bootstrap";
import shopIco from "../../../images/shopping-cart.png";
const UserOrder = ({ orders }) => {
  console.log(orders);
  return (
    <>
      <h2 className="text-center">Order History</h2>
      <div className="d-flex flex-wrap justify-content-center">
        {orders.map((order) => {
          const { products, status } = order;
          return products.map((pd) => {
            return (
              <Card
                className="m-2"
                style={{ width: "100vw", maxWidth: "400px" }}
              >
                <Card.Title className="d-flex justify-content-between mx-2 mt-1">
                  {pd?.name}
                  <span>{status}</span>
                </Card.Title>
                <Card.Body className="d-flex">
                  <img
                    className="avatar mr-3"
                    style={{ objectFit: "cover" }}
                    src={shopIco}
                    alt="shopIco"
                  />
                  <div>
                    <Card.Text>{pd?.description}</Card.Text>
                    <Card.Text>&#2547;{pd?.price}</Card.Text>
                  </div>
                </Card.Body>
              </Card>
            );
          });
        })}
      </div>
    </>
  );
};

export default UserOrder;
